import { User, Organization } from "@platform/types/platform.types";
import { useEnrichedAuthUser } from "./useEnrichedAuthUser";
import { useAuthTracking } from "./useAuthTracking";

export type Args = {
  children: React.ReactNode;
  debug: { enabled: boolean };
  user: User;
  organization: Organization;
  isTokenExpired: boolean;
};

export function AuthTrackingProvider({
  children,
  debug = { enabled: false },
  user,
  organization,
  isTokenExpired,
}: Args) {
  const {
    user: enrichedUser,
    isAuthenticated,
    rawUser,
    rawUserData,
    rawOrgData,
  } = useEnrichedAuthUser({ user, organization, isTokenExpired });

  if (debug.enabled) {
    console.log("[AuthTrackingProvider] Raw user data:", {
      userData: rawUserData,
      orgData: rawOrgData,
      firebaseUser: rawUser ? { uid: rawUser.uid, email: rawUser.email } : null,
    });
  }

  useAuthTracking({
    user: enrichedUser,
    isAuthenticated,
    debug: { enabled: debug.enabled },
  });

  return children;
}
